// A scene's picture full screen (Keaton 2026-10-31: "view a scene's frame full screen or bigger on the stage"). A tap
// anywhere, the close button or Escape closes it. Used by the scene's Frame step, the preview box and the stage's
// frame item (show_on_stage what=frame large=true opens it straight away).
import { useEffect } from "react";
import { Icon } from "./bits";

export function FullFrame({ src, alt = "", title, onClose }: { src: string; alt?: string; title?: string; onClose: () => void }) {
  useEffect(() => {
    const key = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [onClose]);
  return (
    <div className="full-frame" role="dialog" aria-modal="true" aria-label={title ?? "The picture, full screen"} data-action="frame.full" onClick={onClose}>
      <img src={src} alt={alt} />
      {title && <p className="full-frame-title">{title}</p>}
      <button type="button" className="full-frame-close" aria-label="Close" onClick={onClose}>
        <Icon name="close" size={20} />
      </button>
    </div>
  );
}

/** The small "full screen" button that opens it. */
export function FullFrameButton({ label, onOpen, className = "btn btn-quiet btn-small" }: { label: string; onOpen: () => void; className?: string }) {
  return (
    <button type="button" data-action="frame.full-open" className={className} aria-label={label} title={label} onClick={(e) => (e.stopPropagation(), onOpen())}>
      <Icon name="expand" size={14} />
    </button>
  );
}
